import { memo } from 'react';
import classnames from 'classnames';
import NoData from '@gp/components/NoData';
import DoubleYAxisBarLineChart from '@gp/pages/StudioDashboard/StudioOverall/components/DoubleYAxisBarLineChart';
import { isBudgetActualOrForecastCompleteNoData } from '../../utils';

interface IRevenueProfitCompletionBarLineEchartConProps extends IBaseProps {
  data?: IBudgetActualOrForecastCompleteData[];
}

const RevenueProfitCompletionBarLineEchartCon: React.FC<
  IRevenueProfitCompletionBarLineEchartConProps
> = (props) => {
  const { data = [], style, className, ...remains } = props;

  if (isBudgetActualOrForecastCompleteNoData(data))
    return <NoData height={200} constomStyle={{ fontSize: 14 }} />;

  return (
    <DoubleYAxisBarLineChart
      {...remains}
      style={style}
      className={classnames('', className)}
      data={data}
    />
  );
};

export default memo(RevenueProfitCompletionBarLineEchartCon);
